import { Component, input } from '@angular/core';
import { IconComponent } from '@claas/claas-ui-components';

@Component({
  selector: 'app-snackbar-icon',
  templateUrl: './snackbar-icon.component.html',
  styleUrls: ['./snackbar-icon.component.scss'],
  imports: [IconComponent],
})
export class SnackbarIconComponent {
  iconType = input<string>();
}
